import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-angle-right-filled",
  "use": "rt-base-angle-right-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-angle-right-filled\"><defs><style type=\"text/css\"></style></defs><path d=\"M328 758.9V265c0-14.1 16.9-22.1 28.6-13.5l330.8 243.7c11.5 8.4 11.5 25.1 0 33.5L356.6 772.4c-11.7 8.7-28.6 0.6-28.6-13.5z\" p-id=\"3179\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/angle-right-filled.svg
// module id = 1625
// module chunks = 228